import { useCallback } from "react";
import { useSelector } from "react-redux";

import { getEmailNylasInfo } from "@app/store/nylas";

import normalizeEmail from "../util/normalizeEmail";

const useIsCurrentUserEmail = () => {
  const emailNylasInfo = useSelector(getEmailNylasInfo);

  return useCallback(
    (email: string) => {
      return normalizeEmail(email) === normalizeEmail(emailNylasInfo?.connectedEmail);
    },
    [emailNylasInfo]
  );
};

export default useIsCurrentUserEmail;
